import type { ImageMinimumInfo } from '@app-types/commons/images.types.ts';
import type { PaymentMethod } from '@eshop/types/payment.types.ts';
import type { ShippingMethod } from '@eshop/types/shipping.types.ts';

export type PublicPaymentMethod = PaymentMethod & {
  is_active?: boolean;
  image?: ImageMinimumInfo;
};

export type PublicShippingMethod = Omit<ShippingMethod, 'image' | 'is_active'> & {
  is_active?: boolean | string;
  image?: ImageMinimumInfo;
};

export const mergeFooterPaymentMethods = (
  groups: PublicPaymentMethod[][],
): PublicPaymentMethod[] => {
  const methods = new Map<number, PublicPaymentMethod>();
  groups.flat().forEach((method) => {
    if (method.is_active !== false) {
      methods.set(method.id, method);
    }
  });
  return Array.from(methods.values());
};

export const filterActiveFooterShippingMethods = (
  methods: PublicShippingMethod[],
): PublicShippingMethod[] =>
  methods.filter((method) => method.is_active !== false && method.is_active !== 'false');
